import * as React from 'react'
import {Alert, Col, Form, Input, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectTaskItem, NewProjectTaskStore} from 'src/stores/projecttasks-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from 'src/core/services/http.service';
import ProjectEditor from 'src/components/project-editor';
import EditableTooltip from './editable-tooltip/tooltip';
import LabelIcon from './editable-tooltip/label-icon';

let FormItem = Form.Item;


interface NewProjectTaskViewProps {
    companyId: string,
    onClose: (id: string | undefined, item?: NewProjectTaskItem) => void,
    onSave: (id: string) => void;
    newProjectCallback?: (id: string | undefined) => void;
    disabled?: boolean;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    isOnlyUser?: boolean,
    handleSuccessAddTask?: () => void
}

interface NewProjectTaskViewState {
    newProjectId: string | undefined,
    isBusy: boolean,
}

interface ClassFormBodyProps extends WithTranslation {
    companyId: string,
    item: NewProjectTaskItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}> (id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    newProjectCallback?: (id: string | undefined) => void;
    disabled?: boolean,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    isOnlyUser?: boolean,
    handleSuccessAddTask?: () => void
}

export class ProjectTaskFormBody extends React.Component<ClassFormBodyProps> {

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as NewProjectTaskItem;
        return <Form id="modaForm"
                     onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }}
                     onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}
                >
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={t("Name")}>
                        {this.props.getFieldDecorator(nameof<NewProjectTaskItem>('title'), {
                            rules: [{ required: true, message: t('Title required') }],
                        })(
                            <Input disabled={this.props.disabled} placeholder={t("Title")} type="text" />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <EditableTooltip name='task-reference' noIcon>
                    <FormItem label={<LabelIcon >{t("Reference")}</LabelIcon>}>
                            {this.props.getFieldDecorator(nameof<NewProjectTaskItem>('reference'), {
                                rules: [{ required: false, message: t('Reference required') }],
                            })(
                                <Input disabled={this.props.disabled} placeholder={t("Optional reference")} type="text" />
                            )}
                    </FormItem>
                </EditableTooltip>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col span={24}>
                    <FormItem label={t("Project")}>
                        { this.props.getFieldDecorator(nameof<NewProjectTaskItem>('projectId'), {
                            initialValue: item.projectId,
                            rules: [{ required: true, message: t('Project is required') }],
                        })(
                            <ProjectEditor
                                disabled={this.props.disabled}
                                firstTaskOptional={false}
                                onChange={() => this.setState({ newProjectCreated: false })}
                                companyId={this.props.companyId}
                                onCallback={(id) => { if (this.props.newProjectCallback) this.props.newProjectCallback(id) }}
                                companyAllowCir={this.props.companyAllowCir}
                                companyAllowCii={this.props.companyAllowCii}
                                isOnlyUser={this.props.isOnlyUser}
                            />
                        )}
                    </FormItem>
                </Col>
            </Row>
        </Form>
    }
}

@connect(["newProjectTask", NewProjectTaskStore])
class NewProjectTaskView extends React.Component<NewProjectTaskViewProps & WithTranslation & FormComponentProps, NewProjectTaskViewState> {
    private get newProjectTaskStore() {
        return (this.props as any).newProjectTask as NewProjectTaskStore;
    }

    constructor(props: NewProjectTaskViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.newProjectTaskStore.createNew({} as any);
        this.state = {
            newProjectId: undefined,
            isBusy: false,
        }
    }

    componentWillReceiveProps(nextProps: NewProjectTaskViewProps) {
        if (this.newProjectTaskStore.state.result && this.newProjectTaskStore.state.result.isSuccess) {
            nextProps.onClose((this.newProjectTaskStore.state.result as any).aggregateRootId, this.newProjectTaskStore.state.item)
        }
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    if (values.projectId === undefined) {
                        values.projectId = this.state.newProjectId

                        this.newProjectTaskStore.changeUrl(this.props.companyId, this.state.newProjectId as string);
                    }
                    else {
                        this.newProjectTaskStore.changeUrl(this.props.companyId, this.props.form.getFieldValue('projectId'));
                    }
                    self.newProjectTaskStore.change(values);
                    self.newProjectTaskStore.submit().then(result => {
                        if (result.isSuccess) {
                            this.showNotification();
                            resolve();
                        } else {
                            reject();
                        }
                    });
                }
            });
        })
    }

    private showNotification = () => {
        const message = this.props.t("Operation completed successfully");
        this.countDownNotification(notification.success, this.props.t("Notification"), message, "success");
    };

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }
    @autobind
    private onInsertNewProjectTask(id: string | undefined) {
        return new Promise((resolve, reject) => {
            if (this.props.newProjectCallback) {
                this.props.newProjectCallback(id);
                this.props.onClose(undefined);
                resolve();
            }
        })
    }


    @autobind
    private onCancelNewItem() {
        this.newProjectTaskStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New project task")}>
                {this.newProjectTaskStore.state.result && !this.newProjectTaskStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={t(formatMessage(this.newProjectTaskStore.state.result))}
                    />
                }
                <Spin spinning={this.newProjectTaskStore.state.isBusy}>
                    <ProjectTaskFormBody
                        disabled={this.props.disabled}
                        i18n={this.props.i18n}
                        t={this.props.t}
                        tReady={this.props.tReady}
                        item={this.newProjectTaskStore.state.item}
                        getFieldDecorator={getFieldDecorator}
                        onSave={this.onCreateNewItem}
                        companyId={this.props.companyId}
                        newProjectCallback={id => { this.onInsertNewProjectTask(id) }}
                        companyAllowCir={this.props.companyAllowCir}
                        companyAllowCii={this.props.companyAllowCii}
                        isOnlyUser={this.props.isOnlyUser}
                    />
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectTaskView as any) as any) as any as React.ComponentClass<NewProjectTaskViewProps>;